import axios from 'axios';

const api = axios.create({
  baseURL: 'https://amzmp.com.br/cliente/amz_land_backend/',
  // baseURL: 'http://localhost/amz_land_backend',
});

export default api;
